App.SettingsBillingController = Em.Controller.extend
  tariffs :           null
  subscriptions :     null
  billingOperations : null
  billingInfo :       null
  invoices :          null
  organization:       null

  env: Em.inject.service('environment')

  ###
  # Тарифы и подписки на них
  ###
  filteredTariffs:     Em.computed.filterBy('tariffs', 'is_hidden', false)
  tariffSubscriptions: Em.computed.filterBy('subscriptions', 'service.is_tariff', true)

  ###
  # Текущий тариф
  ###
  currentTariff:            Em.computed.alias('tariffSubscriptions.firstObject')
  currentTariffName:        Em.computed.alias('currentTariff.service.name')
  currentTariffMonthPrice:  Em.computed.alias('currentTariff.service.month_price')

  isPaymentMethodSet:       Em.computed.bool('billingInfo.bank_details.bank_details_type')
  isPaymentMethodNotSet:    Em.computed.not('isPaymentMethodSet')


  ###
  # Средства на счету
  ###
  balanceBinding:    'billingInfo.balance'
  isBalanceNegative: Em.computed.lt('balance', 0)

  tariffButtonText: (->
    if (@get('isStatePaywall') || @get('isStatePaywallDeadline')) and @get('isPaymentMethodNotSet')
      return @get('env').translate('billing.form.choose_tariff_and_setup_payment')
    else
      return @get('env').translate('billing.form.choose_tariff')
  ).property('isStatePaywall', 'isStatePaywallDeadline', 'isPaymentMethodNotSet')

  paymentMethod: (->
    bd = @get('billingInfo.bank_details')
    return null unless bd && bd.data
    return Em.I18n.t 'billing.payment_method.tabs.card' if bd.bank_details_type == 'bank_card'
    "#{Em.I18n.t 'billing.payment_method.tabs.bank_account'}, #{bd.data.payer_name}"
  ).property('billingInfo.bank_details.data','billingInfo.bank_details.bank_details_type')

  isPaymentMethodCard: Em.computed.equal('billingInfo.bank_details.bank_details_type', 'bank_card')

  ###
  # Блокировка
  ###
  isGoingToBeBlocked: (->
    blocked    = @get('billingInfo.blocked')
    est_block_date = @get('billingInfo.estimated_block_date')

    not blocked and est_block_date
  ).property(
    'billingInfo.blocked',
    'billingInfo.estimated_block_date')

  estimatedBlockDate: (->
    moment(@get('billingInfo.estimated_block_date')).format('D MMMM')
  ).property('billingInfo.estimated_block_date')

  blockDate: (->
    moment(@get('billingInfo.block_date')).format('D MMMM')
  ).property('billingInfo.block_date')

  paywallDeadline: (->
    moment(@get('billingInfo.paywall_deadline')).format('D MMMM')
  ).property('billingInfo.paywall_deadline')

  ###
  # Счета к оплате
  ###
  notPerformedInvoices: Em.computed.filterBy('invoices', 'is_performed', false)
  notPerformedInvoicesTotal: (->
    @get('notPerformedInvoices').reduce ((sum, it) -> sum + it.get('sum')), 0
  ).property('notPerformedInvoices')

  checkoutDate: (->
    moment(@get('billingInfo.next_checkout_date')).format('D MMMM')
  ).property('billingInfo.next_checkout_date')

  ###
  # Операции со счетом
  ###
  billingOperationsOrder: [ 'actual_date:desc' ]
  sortedBillingOperations: Em.computed.sort('billingOperations', 'billingOperationsOrder')

  # сколько нужно положить денег на счет
  paymentRequiredSum: (->
    sum = @get('billingInfo.balance') - @get('notPerformedInvoicesTotal')
    if sum >= 0
      sum = 0
    -sum
  ).property('notPerformedInvoicesTotal', 'billingInfo')


  ###
  # Состояния: нет счетов, есть счета, долг, блокировка
  ###
  billingState: (->
    if !@get('billingInfo.paywall_accepted')
      if @get('billingInfo.afterPaywallDeadline')
        return 'paywall_deadline'
      else
        return 'paywall'

    if @get('billingInfo.blocked')
      return 'blocked'

    if @get('isGoingToBeBlocked')
      return 'dept'

    if @get('paymentRequiredSum') > 0
      return 'invoices'

    if @get('billingInfo.has_free_tariff')
      return 'free_tariff'

    'normal'
  ).property(
    'billingInfo.has_free_tariff',
    'billingInfo.paywall_accepted',
    'billingInfo.afterPaywallDeadline'
    'billingInfo.blocked',
    'isGoingToBeBlocked',
    'paymentRequiredSum')

  isStateDept:            Em.computed.equal('billingState', 'dept')
  isStateBlocked:         Em.computed.equal('billingState', 'blocked')
  isStateInvoices:        Em.computed.equal('billingState', 'invoices')
  isStateNormal:          Em.computed.equal('billingState', 'normal')
  isStatePaywall:         Em.computed.equal('billingState', 'paywall')
  isStatePaywallDeadline: Em.computed.equal('billingState', 'paywall_deadline')
  isStateFreeTariff:      Em.computed.equal('billingState', 'free_tariff')

  isStateDeptOrBlock: Em.computed.or('isStateDept', 'isStateBlocked')

  showTariffsButton:  Em.computed.or('isStatePaywall', 'isStatePaywallDeadline')
  showBalanceButton:  Em.computed.not('showTariffsButton')
  showOperationsList: Em.computed.not('showTariffsButton')
  showCurrentTariff:  Em.computed.not('showTariffsButton')
  noTariffManage:     Em.computed.bool('billingInfo.has_extra_fees')

  actions:
    setPaymentMethod: ->
      @transitionToRoute('settings.billing.payment_method')
      false

    changeTariff: ->
      # if @get('isPaymentMethodNotSet')
      #   @transitionToRoute('settings.billing.payment_method')
      # else
      @transitionToRoute('settings.billing.tariffs')
      false

    pay: ->
      @transitionToRoute 'settings.billing.pay', @get('paymentRequiredSum')
      false
